// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"a7102966","270":"c32e5907","327":"f2733596","516":"86db2a37","882":"9b97ca04","954":"525dd454"}[chunkId] + ".chunk.css";
};